'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useState } from 'react';
import { useId } from '../hooks/useId';
import { DeprecatedDropdownContext } from './utils/DeprecatedDropdownContext';
export const DeprecatedDropdown = ({ children, id, isOpen = false }) => {
    const [open, setOpen] = useState(isOpen);
    const anchorRef = React.useRef(null);
    const dropdownMenuId = useId(id, 'dropdown-menu');
    const contextValues = {
        open,
        setOpen,
        dropdownMenuId,
        anchorRef
    };
    return (_jsx(DeprecatedDropdownContext.Provider, { value: contextValues, children: children }));
};
